<template>
  <div class="grid grid-cols-1 input-section" :class="customClass">
    <div class="flex items-center gap-2">
      <h1>{{ t('packs') }}</h1>
      <button
          class="px-3 rounded-lg bg-blue-200 hover:bg-blue-300 active:bg-blue-400 text-xl"
          type="button" @click="addItemPack">+
      </button>
    </div>
  </div>
  <div v-for="(item, i) of itemPacks" :key="i" class="input-section border border-orange-400 p-2 my-1" :class="customClass">
    <div class="">
      <!-- <h1>{{ t('sections.pricing') }}</h1> -->
      <div class="input-group">
        <el-form-item :label="t('packName')" class="input-label" style="margin: 5px auto">
          <el-select v-model="item.packID" filterable class="w-full">
            <el-option v-for="(pack, j) in packs" :disabled="pack.disabled" :key="j" :label="$ctx.locale == 'en' ? pack.enName: pack.arName" :value="pack.id">

            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
            :label="t('qty')"
            prop="qty"
            class="input-label"
            style="margin: 5px auto"
        >
          <el-input v-model="item.qty" min="0" type="number"></el-input>
        </el-form-item>

        <!-- <el-form-item
            :label="t('listPriceAmount')"
            prop="listPriceAmount"
            class="input-label"
            style="margin: 5px auto"
        >
          <money-input
              id="list-price"
              :currency="$ctx.currency"
              v-model="item.listPriceAmount"
              @dinero-created="(dinero) => (item.listPriceDinero = dinero)"
          />
        </el-form-item> -->

        <el-form-item
            :label="t('salePriceAmount')"
            prop="salePriceAmount"
            class="input-label"
            style="margin: 5px auto"
        >
          <money-input
              id="sale-price"
              :currency="$ctx.currency"
              v-model="item.salePriceAmount"
              @dinero-created="(dinero) => (item.salePriceDinero = dinero)"
          />
        </el-form-item>
      </div>
    </div>

    <div class="">
      <!-- <h1>{{ t('sections.stockInfo') }}</h1> -->
      <div class="input-group">
        <el-form-item
            :label="t('barcode')"
            prop="barcode"
            class="input-label"
            style="margin: 5px auto"
        >
          <el-tooltip
              class="item"
              effect="dark"
              :content="t('tooltips.barcode')"
              placement="bottom"
          >
            <el-input
                id="barcode"
                v-model="item.barcode"
                :placeholder="t('placeholders.barcode')"
                maxlength="63"
                clearable
                @keypress.enter.prevent=""
            >
            </el-input>
          </el-tooltip>
        </el-form-item>

        <el-form-item :label="t('sku')" prop="sku" class="input-label" style="margin: 5px auto">
          <el-tooltip class="item" effect="dark" :content="t('tooltips.sku')" placement="bottom">
            <el-input
                id="sku"
                v-model="item.sku"
                :placeholder="t('placeholders.sku')"
                maxlength="63"
                clearable
            >
            </el-input>
          </el-tooltip>
        </el-form-item>

      </div>
      <div class="flex items-center justify-between">
        <div>
          <el-form-item prop="disabled" class="input-label" style="margin: 5px auto">
            <el-checkbox v-model="item.disabled" id="disabled">
              {{ t('disabled') }}
            </el-checkbox>
          </el-form-item>
        </div>
        <div v-if="!isValidDate(item.createdAt)">
          <el-button @click="deleteItemPack(item)" text type="danger">{{ t('delete') }}</el-button>
        </div>
      </div>
    </div>
    <CustomPriceSection custom-class="w-full"  v-model="item.itemPackCustomPrices"></CustomPriceSection>

  </div>

</template>

<script setup lang="ts">
import {
  defineProps,
  defineEmits,
  nextTick,
  ref,
  onMounted,
  computed,
  onBeforeMount
} from 'vue'
import { ElInput } from 'element-plus'
import { useI18n } from 'vue-i18n'
import MoneyInput from "@/components/form/MoneyInput.vue";
import ItemPack from "@/models/inventory/ItemPack";
import { v4 as uuidv4 } from 'uuid'
import {Dinero as DineroType} from "dinero.js";
import {watch} from "vue-demi";
import Pack from "@/models/inventory/Pack";
import {useHTTP} from "@/plugins/http";
import CustomPriceSection from "@/views/inventory/items/CustomPriceSection.vue";

// Define props
const props = defineProps({
  modelValue: Array<ItemPack>,
  customClass: String
})

const messages = {
  en: {
    packs: 'Packs',
    newPack: 'New Pack',
    packName: 'Pack Name',
    qty: 'Qty',
    delete: 'Delete',
  },
  ar: {
    packs: 'الرزم',
    newPack: 'رزمة جديدة',
    packName: 'اسم الرزمة',
    qty: 'الكمية',
    delete: 'حذف'

  }
}
const { t } = useI18n({ messages, useScope: 'global' })
const http = useHTTP()

const packs = ref<Array<Pack>>([]);
const itemPacks = ref<Array<ItemPack>>([]);

// Define emits
const emit = defineEmits(['update:modelValue'])

onBeforeMount(() => {
  loadPacks();
})

onMounted(() => {
  itemPacks.value = props.modelValue ? props.modelValue: [];
})


watch(() => itemPacks.value, (newValue) => {
  updateOptions()
  emit('update:modelValue', newValue)
}, {deep: true})

async function loadPacks() {
  try {
    packs.value = await http.get<Array<Pack>>(Pack.ENDPOINT);
    nextTick(() => {
      updateOptions()
    })
  } catch (e) {
    console.log(e)
  }
}

function addItemPack() {
 const newPack = new ItemPack();
  newPack.id = uuidv4()
  itemPacks.value.push(newPack)
}

function isPackUsed(pack: Pack) {
  for (const ip of itemPacks.value) {
    if (ip.packID == pack.id) {
      return true;
    }
  }
  return false;
}

function updateOptions() {
  packs.value.map(p => {
    p.disabled = isPackUsed(p);
    return p;
  })
}

function isValidDate(d: any) {
  return d instanceof Date && !isNaN(d);
}

function deleteItemPack(item: ItemPack) {
  itemPacks.value = itemPacks.value.filter(ip => ip.id != item.id);
}

</script>

<style scoped>
/* Add any styles you need here */
</style>
